module.exports = __webpack_public_path__ + "static/media/H11.1052fd85.png";